import React from 'react'
import classNames from 'classnames'
import {hasApplicationStatus} from '../../services/utils'
import {LeaseApplication, LeaseApplicationStatus} from '../../types/app-types'
import LoaderInline from '../common/LoaderInline'

interface BackgroundCheckCardProps {
  leaseApplication: LeaseApplication
  onBack: (e: any) => void
  onUpdate: (updates: Record<string, any>) => void
}

const BackgroundCheckCard = ({
  onBack,
  leaseApplication
}: BackgroundCheckCardProps) => {
  const url = leaseApplication?.applicationBackgroundUrl
  const isBackgroundCheckCompleted = hasApplicationStatus(
    leaseApplication?.applicationStatus,
    LeaseApplicationStatus.BackgroundCheckCompleted
  )
  return (
    <div className="card-default w-full">
      <div className="card-body-default">
        <div className="flex-grow">
          <h1 className="card-header">Background & Credit Check</h1>

          {!url ? (
            <LoaderInline text="Loading background and credit check form..." />
          ) : (
            <>
              <p className="mb-2">
                Please complete the background and credit check questions:
              </p>
              <iframe
                src={`${url}?embed=1&isMobile=no&hide=logo,tobar,image`}
                width="100%"
                height="600"
                className="border border-solid"
              ></iframe>
            </>
          )}
        </div>
        <div className="card-actions flex-none mt-8 flex flex-row justify-end">
          <button className="btn btn-ghost" onClick={onBack}>
            Back
          </button>
        </div>
      </div>
    </div>
  )
}

export default BackgroundCheckCard
